@if (mode === 'large') {
  <ng-container *ngIfVersion="menuNode?.versions; disabled: !menuNode?.versions">
    <div
      class="menu-item"
      *permissions="menuNode?.permissions; disabled: !menuNode?.permissions; relation: menuNode?.permissionsRelation"
      [class.active]="active"
      [class.category]="menuNode.type === MenuNodeTypes.Category"
      [class.opacity-75]="isNextTeaser"
    >
      <a
        class="mat-tree-node"
        (click)="clickHandler()"
        [routerLink]="menuNode.type === MenuNodeTypes.Link ? menuNode.link : null"
        [fragment]="menuNode.extras?.fragment"
        [queryParams]="menuNode.extras?.queryParams"
      >
        <div class="menu-item-content">
          @if (menuNode.type !== MenuNodeTypes.Category) {
            <button semerisIconButton [attr.aria-label]="menuNode.name">
              <mat-icon>
                {{ menuNode.icon }}
              </mat-icon>
            </button>
          }
          <span class="text-truncate">{{ menuNode.name }}</span>
          @if (isNextTeaser) {
            <span
              class="ml-auto shrink-0 rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide outline-1 outline-dashed"
              [fastTooltip]="tooltip"
            >
              Next
            </span>
          }
        </div>
        <div class="icon-container">
          @for (icon of menuNode?.icons; track icon.icon) {
            @if (!icon.link) {
              <mat-icon [fastTooltip]="icon.tooltip" class="additional-icon">
                {{ icon.icon }}
              </mat-icon>
            }
            @if (icon.link) {
              <a [routerLink]="icon.link" class="icon-with-link" stopPropagation [attr.aria-label]="icon.tooltip">
                <mat-icon [fastTooltip]="icon.tooltip" class="additional-icon">
                  {{ icon.icon }}
                </mat-icon>
              </a>
            }
          }
          @if (showOperation) {
            <mat-icon
              [fastTooltip]="operationName"
              class="operation-icon"
              (click)="onOperationClick($event)"
              >{{ operationIcon }}</mat-icon
            >
          }
        </div>
      </a>
    </div>
  </ng-container>
} @else {
  <ng-container *ngIfVersion="menuNode?.versions; disabled: !menuNode?.versions">
    <div
      class="menu-item minimized"
      (click)="clickHandler()"
      *permissions="menuNode?.permissions; disabled: !menuNode?.permissions; relation: menuNode?.permissionsRelation"
      [class.active]="active"
      [class.opacity-75]="isNextTeaser"
      [fastTooltip]="tooltip"
    >
      <a
        class="mat-tree-node"
        [routerLink]="menuNode.type === MenuNodeTypes.Link ? menuNode.link : null"
        [fragment]="menuNode.extras?.fragment"
        [queryParams]="menuNode.extras?.queryParams"
      >
        @if (menuNode.type !== MenuNodeTypes.Category) {
          <button semerisIconButton [attr.aria-label]="menuNode.name">
            @if (menuNode.icon) {
              <mat-icon>
                {{ menuNode.icon }}
              </mat-icon>
            } @else {
              <span class="short-code">
                {{ menuNode.shortCode | uppercase }}
              </span>
            }
          </button>
        }
      </a>
    </div>
  </ng-container>
}

@if (menuNode.children && menuNode.children.length > 0 && menuNode.active) {
  <div class="sub-menu">
    @for (child of menuNode.children; track child.name) {
      <semeris-sidenav-item
        [menuNode]="child"
        [mode]="mode"
        [nextTeaserInert]="nextTeaserInert"
        (menuClick)="menuClick.emit($event)"
      ></semeris-sidenav-item>
    }
  </div>
}
